export default {
  checklists: [],
  checklist: undefined,
};
